import { IconMinus, IconPlus } from '@tabler/icons-react';
import _debounce from 'lodash/debounce';
import React, { useContext } from 'react';
import { Accordion } from 'react-bootstrap';
import { useAccordionButton } from 'react-bootstrap/AccordionButton';
import AccordionContext from 'react-bootstrap/AccordionContext';
import { toast } from 'sonner';
import { postApi } from '../../../../api/call.api';
import { urlApi } from '../../../../api/url.api';
import ToggleBtn from '../../../../components/Toggle/ToggleBtn';
import { loadingHide, loadingShow } from '../../../../loadingUi/loading.controller';


const ContactBlock = ({ dragButton, linkId, callback, data }) => {

    function ContextAwareToggle({ eventKey, callback }) {
        const { activeEventKey } = useContext(AccordionContext);

        const decoratedOnClick = useAccordionButton(
            eventKey,
            () => callback && callback(eventKey),
        );

        const isCurrentEventKey = activeEventKey === eventKey;

        return (
            <div className="flex items-center rounded-md bg-[#E8EDFC] gap-3 p-2 cursor-pointer" onClick={decoratedOnClick}>
                {dragButton}
                <p className='mb-0 text-sm font-semibold'> Contact Us </p>
                <div className="ms-auto"></div>
                <ToggleBtn onClickFunction={(e) => onBlockStatusUpdate(e)} state={data?.status == 1} />
                <button className='bg-white p-1.5 rounded-full' onClick={decoratedOnClick}>{isCurrentEventKey ? <IconMinus size={20} /> : <IconPlus size={20} />}</button>
            </div>
        );
    }

    async function update(postDetails) {
        let postData = {
            linkId: linkId,
            postData: postDetails
        }
        let resp = await postApi(postData, urlApi.editBlockDataOfCard);
        loadingHide();
        if (resp?.responseCode === 200) {
            if (callback) {
                callback();
            }
        }
        if (resp.responseCode === 500) {
            toast.error(resp.message);
        }
    }

    const onBlockStatusUpdate = (e) => {
        e.stopPropagation();
        loadingShow();
        let status = data?.status == 1 ? 2 : 1;
        let postDetails = [{
            "key": "contactUs.status",
            "value": status
        }, {
            "key": "contactUs.floatingButtonStatus",
            "value": status == 2 ? false : status == 1 ? true : false
        }]

        update(postDetails);
    }

    const onTitleChange = (e) => {
        let title = e.target.value;
        let postDetails = [{
            "key": "contactUs.title",
            "value": title
        }]
        update(postDetails);
    }

    const onFloatingButtonTextChange = (e) => {
        let floatingButtonText = e.target.value;
        let postDetails = [{
            "key": "contactUs.floatingButtonText",
            "value": floatingButtonText
        }]
        update(postDetails);
    }

    const onFloatingActionButtonStatusChange = () => {
        if (data?.status == 2) return;
        let actionButton = !data?.floatingButtonStatus;
        let postDetails = [{
            "key": "contactUs.floatingButtonStatus",
            "value": actionButton
        }]
        update(postDetails);
    }

    const onContactNumberLabelChange = (e) => {
        let label = e.target.value;
        let postDetails = [{
            "key": "contactUs.contactNumberLabel",
            "value": label
        }]
        update(postDetails);
    }

    const onContactNumberChange = (e) => {
        let mobile = e.target.value;
        const mobileNumberRegex = /^[6-9]\d{9}$/;
        if (mobile.length == 10) {
            if (mobileNumberRegex.test(mobile)) {
                let postDetails = [{
                    "key": "contactUs.contactNumber",
                    "value": mobile
                }]
                update(postDetails);
            } else {
                toast.error('Please enter a valid mobile number');
            }
        } else {
            toast.error('Please enter 10 digit mobile number');
        }
    }

    const onEmailIdLabelChange = (e) => {
        let label = e.target.value;
        let postDetails = [{
            "key": "contactUs.emailIdLabel",
            "value": label
        }]
        update(postDetails);
    }

    const onEmailIdChange = (e) => {
        let email = e.target.value;
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (emailRegex.test(email)) {
            let postDetails = [{
                "key": "contactUs.emailId",
                "value": email
            }]
            update(postDetails);
        }
        else {
            toast.error('Please enter a valid email id');
        }
    }

    const onAddressLabelChange = (e) => {
        let label = e.target.value;
        let postDetails = [{
            "key": "contactUs.addressLabel",
            "value": label
        }]
        update(postDetails);
    }

    const onAddressLine1Change = (e) => {
        let addressLine1 = e.target.value;
        let postDetails = [{
            "key": "contactUs.addressLine1",
            "value": addressLine1
        }]
        update(postDetails);
    }

    const onAddressLine2Change = (e) => {
        let addressLine2 = e.target.value;
        let postDetails = [{
            "key": "contactUs.addressLine2",
            "value": addressLine2
        }]
        update(postDetails);
    }

    const onCityChange = (e) => {
        let city = e.target.value;
        let postDetails = [{
            "key": "contactUs.addressCity",
            "value": city
        }]
        update(postDetails);
    }

    const onStateChange = (e) => {
        let state = e.target.value;
        let postDetails = [{
            "key": "contactUs.addressState",
            "value": state
        }]
        update(postDetails);
    }

    const onCountryChange = (e) => {
        let country = e.target.value;
        let postDetails = [{
            "key": "contactUs.addressCountry",
            "value": country
        }]
        update(postDetails);
    }

    const onZipCodeChange = (e) => {
        let zipCode = e.target.value;
        const zipCodeRegex = /^[1-9][0-9]{5}$/;
        if (zipCodeRegex.test(zipCode)) {
            let postDetails = [{
                "key": "contactUs.addressZipCode",
                "value": zipCode
            }]
            update(postDetails);
        } else {
            toast.error('Please enter a valid zip code');
        }
    }

    const onActionButtonStatusChange = () => {
        let actionButton = !data?.addressActionButtonStatus;
        let postDetails = [{
            "key": "contactUs.addressActionButtonStatus",
            "value": actionButton
        }]
        update(postDetails);
    }

    const onMapUrlChange = (e) => {
        let mapUrl = e.target.value;
        let postDetails = [{
            "key": "contactUs.addressGoogleMapUrl",
            "value": mapUrl
        }]
        update(postDetails);
    }

    const onActionButtonTextChange = (e) => {
        let actionButtonText = e.target.value;
        let postDetails = [{
            "key": "contactUs.addressActionButtonText",
            "value": actionButtonText
        }]
        update(postDetails);
    }

    const onAddressStatusChange = () => {
        let actionButton = !data?.addressStatus;
        let postDetails = [{
            "key": "contactUs.addressStatus",
            "value": actionButton
        }]
        update(postDetails);
    }

    const onEmailIdStatusChange = () => {
        let actionButton = !data?.emailIdStatus;
        let postDetails = [{
            "key": "contactUs.emailIdStatus",
            "value": actionButton
        }]
        update(postDetails);
    }

    const onContactNumberStatusChange = () => {
        let actionButton = !data?.contactNumberStatus;
        let postDetails = [{
            "key": "contactUs.contactNumberStatus",
            "value": actionButton
        }]
        update(postDetails);
    }

    return (

        <div className='w-full rounded-md overflow-hidden border border-[#E8EDFC]'>
            <Accordion>
                <Accordion.Item eventKey="0">
                    <ContextAwareToggle eventKey={"0"} />
                    <Accordion.Body>
                        <div className="p-2">
                            <p className="text-sm font-semibold mb-1.5">Title</p>
                            <input type="text" className="form-control mb-4 w-full" placeholder="" id={'title'} defaultValue={data?.title} onChange={_debounce((e) => onTitleChange(e), 600)} maxLength={255} />
                            <div className='flex items-center gap-2 mb-2'> <p className="text-sm font-semibold">Floating Button</p><ToggleBtn state={data?.floatingButtonStatus} onClickFunction={() => onFloatingActionButtonStatusChange()} /></div>
                            <div className='px-3 py-4 mb-4 border border-[#E8EDFC] rounded-md'>
                                <div className="flex items-end gap-2">
                                    <div>
                                        <p className="text-xs font-extralight mb-1.5">Button text</p>
                                        <input type="text" className="form-control w-full" placeholder="Button Text" id={'buttonText'} defaultValue={data?.floatingButtonText || 'Add to Contact'} onChange={_debounce((e) => onFloatingButtonTextChange(e), 600)} maxLength={255} />
                                    </div>
                                    <button className='flex items-center gap-3 py-1.5 pe-1.5 ps-3 text-sm font-semibold !bg-primary ms-auto rounded-full text-white'>{data?.floatingButtonText || 'Add to Contact'} <div className='bg-white rounded-full p-2'> <IconPlus color='black' size={20} /> </div></button>
                                </div>
                            </div>
                            <div className='flex items-center gap-2 mb-2'> <p className="text-sm font-semibold">Contact Number</p><ToggleBtn state={data?.contactNumberStatus} onClickFunction={() => onContactNumberStatusChange()} /></div>
                            <div className='px-3 py-4 mb-4 border border-[#E8EDFC] rounded-md'>
                                <div className="flex items-end gap-2 -mt-1">
                                    <div className='w-1/2'>
                                        <p className="text-xs font-extralight mb-1.5">Label</p>
                                        <input type="text" className="form-control w-full" id={'label'} defaultValue={data?.contactNumberLabel} onChange={_debounce((e) => onContactNumberLabelChange(e), 600)} maxLength={255} />
                                    </div>
                                    <div className='w-1/2'>
                                        <p className="text-xs font-extralight mb-1.5">Number</p>
                                        <input type="number" className="form-control w-full" id={'mobile'} defaultValue={data?.contactNumber} onChange={_debounce((e) => onContactNumberChange(e), 2000)} maxLength={10} />
                                    </div>
                                </div>
                            </div>
                            <div className='flex items-center gap-2 mb-2'> <p className="text-sm font-semibold">Email ID</p> <ToggleBtn state={data?.emailIdStatus} onClickFunction={() => onEmailIdStatusChange()} /></div>
                            <div className='px-3 py-4 mb-4 border border-[#E8EDFC] rounded-md'>
                                <div className="flex items-end gap-2 -mt-1">
                                    <div className='w-1/2'>
                                        <p className="text-xs font-extralight mb-1.5">Label</p>
                                        <input type="text" className="form-control w-full" id={'label'} defaultValue={data?.emailIdLabel} onChange={_debounce((e) => onEmailIdLabelChange(e), 600)} maxLength={255} />
                                    </div>
                                    <div className='w-1/2'>
                                        <p className="text-xs font-extralight mb-1.5">Email</p>
                                        <input type="email" autoComplete='email' className="form-control w-full" id={'email'} defaultValue={data?.emailId} onChange={_debounce((e) => onEmailIdChange(e), 2000)} />
                                    </div>
                                </div>
                            </div>
                            <div className='flex items-center gap-2 mb-2'> <p className="text-sm font-semibold">Address</p><ToggleBtn state={data?.addressStatus} onClickFunction={() => onAddressStatusChange()} /></div>
                            <div className='px-3 py-4 mb-4 border border-[#E8EDFC] rounded-md'>
                                <div className="grid grid-cols-2 gap-2 -mt-1 items-end">
                                    <div className='col-span-2'>
                                        <p className="text-xs font-extralight mb-1.5">Label</p>
                                        <input type="text" className="form-control w-full" id={'label'} defaultValue={data?.addressLabel} maxLength={255} onChange={_debounce((e) => onAddressLabelChange(e), 600)} />
                                    </div>
                                    <div className=''>
                                        <p className="text-xs font-extralight mb-1.5">Address Line 1</p>
                                        <input type="text" autoComplete='address' className="form-control w-full" id={'address-line-1'} defaultValue={data?.addressLine1} onChange={_debounce((e) => onAddressLine1Change(e), 600)} />
                                    </div>
                                    <div className=''>
                                        <p className="text-xs font-extralight mb-1.5">Address Line 2</p>
                                        <input type="text" autoComplete='address' className="form-control w-full" id={'address-line-2'} defaultValue={data?.addressLine2} onChange={_debounce((e) => onAddressLine2Change(e), 600)} />
                                    </div>
                                    <div className=''>
                                        <p className="text-xs font-extralight mb-1.5">City</p>
                                        <input type="text" autoComplete='address' className="form-control w-full" id={'city'} defaultValue={data?.addressCity} onChange={_debounce((e) => onCityChange(e), 600)} />
                                    </div>
                                    <div className=''>
                                        <p className="text-xs font-extralight mb-1.5">State</p>
                                        <input type="text" autoComplete='address' className="form-control w-full" id={'state'} defaultValue={data?.addressState} onChange={_debounce((e) => onStateChange(e), 600)} />
                                    </div>
                                    <div className=''>
                                        <p className="text-xs font-extralight mb-1.5">Country</p>
                                        <input type="text" autoComplete='address' className="form-control w-full" id={'country'} defaultValue={data?.addressCountry} onChange={_debounce((e) => onCountryChange(e), 600)} />
                                    </div>
                                    <div className=''>
                                        <p className="text-xs font-extralight mb-1.5">Zip Code</p>
                                        <input type="text" autoComplete='address' className="form-control w-full" id={'zip-code'} defaultValue={data?.addressZipCode} onChange={_debounce((e) => onZipCodeChange(e), 600)} maxLength={6} />
                                    </div>
                                    <div className=''>
                                        <div className='flex gap-2 items-center mb-2'>  <p className="text-xs font-extralight">Action Button</p> <ToggleBtn state={data?.addressActionButtonStatus} onClickFunction={() => onActionButtonStatusChange()} /> </div>
                                        <input type="text" autoComplete='address' className="form-control w-full" id={'action-button'} defaultValue={data?.addressActionButtonText || 'Direction'} onChange={_debounce((e) => onActionButtonTextChange(e), 600)} />
                                    </div>
                                    <div className=''>
                                        <p className="text-xs font-extralight mb-1.5">Google Map URL</p>
                                        <input type="text" autoComplete='address' className="form-control w-full" id={'map-url'} defaultValue={data?.addressGoogleMapUrl} onChange={_debounce((e) => onMapUrlChange(e), 600)} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
        </div>
    )
}

export default ContactBlock